import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import BlueAddCart from '@/components/BlueAction/AddToCartButton.vue';
export default defineComponent({
    name: 'header-menu-product-detail-page',
    components: { BlueAddCart },
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
    data() {
        return {
            predScrollPos: 0,
            scrollDown: false,
            scrollTop: false,
        };
    },
    methods: {
        scrollFunction() {
            switch (true) {
                // Erst ab 400px vor Top reagieren
                case window.scrollY < this.predScrollPos && window.scrollY < 400:
                    this.predScrollPos = window.scrollY;
                    this.scrollDown = false;
                    this.scrollTop = true;
                    break;
                case window.scrollY > 400:
                    this.predScrollPos = window.scrollY;
                    this.scrollDown = true;
                    this.scrollTop = false;
                    break;
            }
        },
    },
    mounted() {
        this.predScrollPos = window.scrollY;
        window.addEventListener('scroll', () => {
            this.scrollFunction();
        });
    },
});
